export const iconFontAwesomeHumanitarianPeopleArrows = (
	<i className="fa-solid fa-people-arrows"></i>
);
